import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  error: null,
  singleNotice:undefined,
  calenderData:null
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const noticeSlice = createSlice({
  name: "notice",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    allNoticeFetched: (state, action) => {
      state.actionsLoading = false;
      state.entities = action.payload.entities;
      state.error = null;
    },

    noticeFetched: (state, action) => {
      state.actionsLoading = false;
      state.singleNotice = action.payload.singleNotice;
      state.error = null;
    },

  
    


    noticeDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.hrms_event_notice__id !== action.payload.id
      );
    },

    YearlyCalenderDataFetched: (state, action) => {
      state.actionsLoading = false;
      state.calenderData = action.payload.calenderData;
      state.error = null;
    },

  },
});
